import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const categories = [
    {
        id: 'living-room',
        label: 'Living Room Ideas',
        desc: 'Create a captivating living space with bold statement pieces, layered lighting, and curated colour palettes.',
        images: [
            { url: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=700&q=80', caption: 'Modern Minimalist Living Room' },
            { url: '/images/False Ceiling Design.jpg', caption: 'Luxury False Ceiling with Cove Lighting' },
            { url: '/images/Pooja & Foyer Design.jpg', caption: 'Elegant Pooja & Foyer Entrance' },
            { url: 'https://images.unsplash.com/photo-1618219944342-824e40a13285?w=700&q=80', caption: 'Luxury Earthy Tones Lounge' },
            { url: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=700&q=80', caption: 'Contemporary Open Plan' },
            { url: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=700&q=80', caption: 'Cosy Sectional Setup' },
        ],
    },
    {
        id: 'bedroom',
        label: 'Bedroom Ideas',
        desc: 'Transform your bedroom into a haven of rest with soothing palettes, bespoke wardrobes, and atmospheric lighting.',
        images: [
            { url: 'https://images.unsplash.com/photo-1540518614846-7eded433c457?w=700&q=80', caption: 'Luxurious Master Suite' },
            { url: 'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=700&q=80', caption: 'Serene Neutral Bedroom' },
            { url: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=700&q=80', caption: 'Moody Blue Retreat' },
            { url: 'https://images.unsplash.com/photo-1567016432779-094069958ea5?w=700&q=80', caption: 'Japandi Style Bedroom' },
            { url: 'https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=700&q=80', caption: 'Kids Bedroom with Study Zone' },
            { url: 'https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=700&q=80', caption: 'Boho Chic Guest Room' },
        ],
    },
    {
        id: 'kitchen',
        label: 'Kitchen Ideas',
        desc: 'Smart, stylish modular kitchens with premium materials — designed for the way you actually cook and live.',
        images: [
            { url: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=700&q=80', caption: 'Sleek White Modular Kitchen' },
            { url: 'https://images.unsplash.com/photo-1556909172-54557c7e4fb7?w=700&q=80', caption: 'Dark Dramatic Chef Kitchen' },
            { url: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=700&q=80', caption: 'Warm Wood Toned Kitchen' },
            { url: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?w=700&q=80', caption: 'Island Kitchen with Bar Stools' },
            { url: 'https://images.unsplash.com/photo-1543269664-56d93c1b41a6?w=700&q=80', caption: 'Navy Blue Shaker Kitchen' },
            { url: 'https://images.unsplash.com/photo-1615460549969-36fa19521a4f?w=700&q=80', caption: 'Compact Galley Kitchen' },
        ],
    },
    {
        id: 'office',
        label: 'Office Design Ideas',
        desc: 'Productive, inspiring office spaces — from corporate HQs to home offices — designed to reflect your brand.',
        images: [
            { url: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=700&q=80', caption: 'Modern Corporate Office' },
            { url: 'https://images.unsplash.com/photo-1497366412874-3415097a27e7?w=700&q=80', caption: 'Creative Agency Workspace' },
            { url: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=700&q=80', caption: 'Minimalist Home Office' },
            { url: 'https://images.unsplash.com/photo-1593476550610-87baa860004a?w=700&q=80', caption: 'Co-working Lounge Zone' },
            { url: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=700&q=80', caption: 'Executive Suite Design' },
            { url: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=700&q=80', caption: 'Library & Study Corner' },
        ],
    },
    {
        id: 'small-space',
        label: 'Small Space Ideas',
        desc: 'Smart design solutions that make every square foot count — compact doesn\'t have to mean cramped.',
        images: [
            { url: 'https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=700&q=80', caption: 'Studio Apartment Makeover' },
            { url: 'https://images.unsplash.com/photo-1560185127-6ed189bf02f4?w=700&q=80', caption: 'Murphy Bed Living Room Combo' },
            { url: 'https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=700&q=80', caption: 'Loft Bed with Desk Below' },
            { url: 'https://images.unsplash.com/photo-1569152811536-fb47aced8409?w=700&q=80', caption: 'Mini Kitchen Smart Storage' },
            { url: 'https://images.unsplash.com/photo-1617103996702-96ff29b1c467?w=700&q=80', caption: 'Tiny Bathroom Luxury Touches' },
            { url: 'https://images.unsplash.com/photo-1505873242700-f289a29e1e0f?w=700&q=80', caption: 'Balcony Converted to Office' },
        ],
    },
];

function Lightbox({ image, onClose }) {
    if (!image) return null;
    return (
        <div className="fixed inset-0 z-[200] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
            <div className="relative max-w-4xl w-full" onClick={e => e.stopPropagation()}>
                <button onClick={onClose} className="absolute -top-12 right-0 text-white text-3xl hover:text-[#2E63E8] transition-colors">×</button>
                <img src={image.url} alt={image.caption} className="w-full max-h-[80vh] object-contain rounded-2xl" />
                <p className="text-gray-300 text-center mt-3 text-sm">{image.caption}</p>
            </div>
        </div>
    );
}

export default function DesignIdeasPage() {
    const [searchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState(categories[0].id);
    const [lightboxImage, setLightboxImage] = useState(null);

    useEffect(() => {
        const id = searchParams.get('id');
        if (id && categories.find(c => c.id === id)) {
            setActiveTab(id);
        }
    }, [searchParams]);

    const current = categories.find(c => c.id === activeTab);

    return (
        <>
            {/* Lightbox */}
            <Lightbox image={lightboxImage} onClose={() => setLightboxImage(null)} />

            {/* Hero */}
            <section className="relative pt-36 pb-24 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-[#0A1128] via-[#1C2541] to-[#0D0D0D]" />
                <div className="relative max-w-7xl mx-auto px-4 text-center">
                    <span className="inline-block bg-[#2E63E8]/20 border border-[#2E63E8]/40 text-[#2E63E8] text-xs font-semibold px-5 py-2 rounded-full mb-5 uppercase tracking-widest">
                        Inspiration Gallery
                    </span>
                    <h1 className="text-5xl md:text-7xl font-bold text-white mb-5">Design Ideas</h1>
                    <p className="text-gray-300 text-lg max-w-2xl mx-auto">
                        Explore curated interior design ideas across every room and style. Get inspired for your next project.
                    </p>
                </div>
            </section>

            {/* Category Tabs */}
            <section className="bg-white border-b sticky top-[105px] z-40 shadow-sm">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex overflow-x-auto gap-1 py-3">
                        {categories.map(cat => (
                            <button
                                key={cat.id}
                                onClick={() => setActiveTab(cat.id)}
                                className={`flex-shrink-0 px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-200
                  ${activeTab === cat.id ? 'bg-[#2E63E8] text-white shadow-md' : 'text-gray-600 hover:bg-gray-100'}`}
                            >
                                {cat.label}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* Gallery Section */}
            <section className="section-pad bg-[#F8F9FA]">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="mb-10">
                        <h2 className="text-3xl font-bold text-gray-900 mb-3">{current.label}</h2>
                        <p className="text-gray-600 max-w-2xl">{current.desc}</p>
                    </div>

                    {/* Masonry-style grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                        {current.images.map((img, i) => (
                            <div
                                key={i}
                                className={`group relative rounded-2xl overflow-hidden shadow-md cursor-pointer card-hover h-80
                  ${i === 0 ? 'sm:col-span-2 lg:col-span-1' : ''}`}
                                onClick={() => setLightboxImage(img)}
                            >
                                <img
                                    src={img.url}
                                    alt={img.caption}
                                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-5">
                                    <div>
                                        <p className="text-white font-semibold text-sm">{img.caption}</p>
                                        <p className="text-[#2E63E8] text-xs mt-1 font-medium">Click to view full size →</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-12">
                        <a href="/contact" className="btn-yellow inline-block px-10 py-4 text-base">
                            Get This Look for Your Home →
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
}
